import { pluralizeCzech } from "@marekl/adminer/format";

import type { BuildResult } from "../../../lib/queries/startlists";

/**
 * What „Aktualizovat" just did, in one Czech sentence.
 *
 * Every field of BuildResult is named here, and that is the whole point.
 * The page used to test five of the eight and report „Listina odpovídá
 * přihláškám" for the other three — so pressing the button on „Soutěž se
 * koná i ve dnech, které listina nemá" added the day and then announced
 * that nothing had changed. The three it forgot were exactly the ones
 * the banner advertises: days added, days removed, blocks swept.
 *
 * Built as a list of parts rather than a template, because a sentence
 * naming five things that all happen to be zero says less than one
 * naming the two that are not.
 */
export function buildSummary(res: BuildResult): string {
  const added: string[] = [];
  const removed: string[] = [];

  const say = (
    into: string[],
    n: number,
    forms: readonly [one: string, few: string, many: string],
  ) => {
    if (n > 0) into.push(`${n} ${pluralizeCzech(n, forms)}`);
  };

  say(added, res.added, ["přihláška", "přihlášky", "přihlášek"]);
  say(added, res.blocks, ["kategorie", "kategorie", "kategorií"]);
  say(added, res.days, ["den", "dny", "dní"]);

  say(removed, res.withdrawn, ["odhlášená", "odhlášené", "odhlášených"]);
  say(removed, res.removed, ["smazaná", "smazané", "smazaných"]);
  say(removed, res.blocks_removed, ["prázdný blok", "prázdné bloky", "prázdných bloků"]);
  say(removed, res.days_removed, ["prázdný den", "prázdné dny", "prázdných dnů"]);

  const sentences: string[] = [];
  if (added.length) sentences.push(`Doplněno: ${added.join(", ")}.`);
  if (removed.length) sentences.push(`Odebráno: ${removed.join(", ")}.`);
  if (res.regrouped > 0) {
    const forms = ["přihláška", "přihlášky", "přihlášek"] as const;
    sentences.push(`Přeskupeno ${res.regrouped} ${pluralizeCzech(res.regrouped, forms)}.`);
  }

  return sentences.length ? sentences.join(" ") : "Listina odpovídá přihláškám.";
}
